<template>
  <v-card class="mb-2">
    <v-card-title> Transaction Info </v-card-title>
    <v-simple-table>
      <tr>
        <td>Collected Amount</td>
        <td>
          <span class="font-weight-bold">{{
            transactionInfo.total_coll_amt
              ? transactionInfo.total_coll_amt
              : null
          }}</span>
        </td>
      </tr>
      <tr>
        <td class="">Service Charge</td>
        <td class="font-weight-bold">
          {{
            transactionInfo.service_charge
              ? transactionInfo.service_charge
              : null
          }}
        </td>
      </tr>

      <tr>
        <td>Transfer Amount</td>
        <td class="font-weight-bold">
          {{
            transactionInfo.transfer_amt ? transactionInfo.transfer_amt : null
          }}
        </td>
      </tr>
      <tr>
        <td>Exchange Rate</td>
        <td class="font-weight-bold">
          1 {{ transactionInfo.coll_currency }} = {{ transactionInfo.rate }}
          {{ transactionInfo.pay_currency }}
        </td>
      </tr>
      <tr>
        <td>Payout Amount</td>
        <td class="font-weight-bold">
          <span class="font-weight-bold text--primary">
            {{
              transactionInfo.payout_amt ? transactionInfo.payout_amt : null
            }}</span
          >
        </td>
      </tr>
      <tr>
        <td>Purpose of Remittance</td>
        <td class="font-weight-bold">
          {{
            transactionInfo.purpose_of_remittance
              ? transactionInfo.purpose_of_remittance.value
              : null
          }}
        </td>
      </tr>
      <tr>
        <td>Bank Reciept</td>
        <td>
          <img
            v-if="transactionInfo.bank_receipt"
            class="ml-1"
            height="40"
            width="50"
            :src="
              transactionInfo.bank_receipt ? transactionInfo.bank_receipt : null
            "
            @click="
              handleImageViewer(transactionInfo.bank_receipt, 'showImage')
            "
          />
        </td>
      </tr>
      <tr>
        <td colspan="2">
          Deposit Type:
          <span class="font-weight-bold">{{
            transactionInfo.payment_mode ? transactionInfo.payment_mode : null
          }}</span>
        </td>
      </tr>
    </v-simple-table>
    <image-viewer
      :showDialog="isImageViewer"
      :picture="{
        PicHeight: '435',
        PicWidth: 600,
        Pic: imageViewerUrl,
      }"
      @closeImageViewer="handleCloseImageViewer"
    ></image-viewer>
  </v-card>
</template>

<script>
import imageViewer from "@/utils/imageViewer.vue";
export default {
  data() {
    return {
      isImageViewer: false,
      imageViewerUrl: "",
    };
  },
  components: {
    imageViewer,
  },
  props: {
    transactionInfo: {
      type: Object,
    },
  },
  methods: {
    handleCloseImageViewer() {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = "";
    },
    handleImageViewer(url) {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = url;
    },
  },
};
</script>

<style lang="scss" scoped>
th,
td {
  border-bottom: 1px solid rgb(231, 229, 229);
  border-collapse: collapse;
  padding: 5px;
}
</style>
